import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FrontLayoutRoutingModule } from './front-layout-routing.module';
import { FrontLayoutComponent } from './front-layout.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { CmsserviceService} from '../common-cms-service/cmsservice.service';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UpcomingEventsComponent } from './upcoming-events/upcoming-events.component';
import { AcademyComponent } from './academy/academy.component';
import { UAEComponent } from './uae/uae.component';
import { GcseClassesComponent } from '../landingpages/gcse-classes/gcse-classes.component'; //new component 
import { TimetableComponent } from '../calender/timetable/timetable.component';
import { GcsetimetableComponent } from '../calender/gcsetimetable/gcsetimetable.component';
import { TopicTestComponent } from '../calender/topic-test/topic-test.component';
import { WebinarComponent } from './webinar/webinar.component';
import { ElevplusClassesComponent } from '../landingpages/elevplus-classes/elevplus-classes.component';
import { ProductServicesComponent } from '../landingpages/product-services/product-services.component';
import { CountUpDirective } from '../count-up.directive';
import { ConsortiumComponent } from './consortiums/consortium/consortium.component';
import { PageOneComponent } from './consortiums/page-one/page-one.component';
import { PageCsseComponent } from './consortiums/page-csse/page-csse.component';
import { PageRedbridgeComponent } from './consortiums/page-redbridge/page-redbridge.component';
import { PageBucksComponent } from './consortiums/page-bucks/page-bucks.component';
import { PageW11plusComponent } from './consortiums/page-w11plus/page-w11plus.component';
import { GrammarSchoolsComponent } from './consortiums/grammar-schools/grammar-schools.component';
import { ElevPlusTestsComponent } from './calendar/elev-plus-tests/elev-plus-tests.component';
import { GcseTestsComponent } from './calendar/gcse-tests/gcse-tests.component';
import { PageQeComponent } from './consortiums/page-qe/page-qe.component';
import { PageHbsComponent } from './consortiums/page-hbs/page-hbs.component';
import { PageReadingComponent } from './consortiums/page-reading/page-reading.component';
import { PageSuttonComponent } from './consortiums/page-sutton/page-sutton.component';
import { PageSloughComponent } from './consortiums/page-slough/page-slough.component';
import { RapidCourseComponent } from './rapid-course/rapid-course.component';
import { PageBexleyComponent } from './consortiums/page-bexley/page-bexley.component';
import { CchsGirlsComponent } from './consortiums/cchs-girls/cchs-girls.component';
import { PageFsceComponent } from './consortiums/page-fsce/page-fsce.component';
import { PageReadingBoysComponent } from './consortiums/page-reading-boys/page-reading-boys.component';
import { PageReadingGirlsComponent } from './consortiums/page-reading-girls/page-reading-girls.component';
import { SatTestComponent } from './calendar/sat-test/sat-test.component';
import { CreativeWritingComponent } from './creative-writing/creative-writing.component';
import { SpagCourseComponent } from './spag-course/spag-course.component';
import { FreeResourseComponent } from './free-resourse/free-resourse.component';
import { PageTraffordComponent } from './consortiums/page-trafford/page-trafford.component';
import { AdmissionOpenComponent } from './admission-open/admission-open.component';
import { KeyDatesComponent } from './key-dates/key-dates.component';
import { LatymerComponent } from './consortiums/latymer/latymer.component';
import { BootcampComponent } from './bootcamp/bootcamp.component';
import { BridgeCourseComponent } from './bridge-course/bridge-course.component';
import { PythonCourseComponent } from './python-course/python-course.component';
import { EightWeekCombinedComponent } from './eight-week-combined/eight-week-combined.component';
import { QuestionBankComponent } from './question-bank/question-bank.component';
import { BlogsComponent } from './blogs/blogs.component';
import { BlogsReadComponent } from './blogs-read/blogs-read.component';
import { TestComponent } from './test/test.component';
import { DataScienceComponent } from './data-science/data-science.component';
import { ElevenPlusSprintComponent } from './eleven-plus-sprint/eleven-plus-sprint.component';
import { ElevenPlusCwComponent } from './eleven-plus-cw/eleven-plus-cw.component';
import { LocationsComponent } from './location/locations/locations.component';
import { LocationDetailsComponent } from './location/location-details/location-details.component';
import { SafeUrlPipe } from './location/safe-url.pipe';
import { GcseLocationComponent } from './location/gcse-location/gcse-location.component';
import { GcseLocationDetailsComponent } from './location/gcse-location-details/gcse-location-details.component';
import { ElevenTopicTestComponent } from './eleven-topic-test/eleven-topic-test.component';
import { ElevenplusHelpclubComponent } from './elevenplus-helpclub/elevenplus-helpclub.component';
import { GcseHelpClubComponent } from './gcse-help-club/gcse-help-club.component';
import { YearFourCalComponent } from './calendar/year-four-cal/year-four-cal.component';
import { YearTenMocktestComponent } from './calendar/year-ten-mocktest/year-ten-mocktest.component';
import { OfferBannerComponent } from "./offer-banner/offer-banner.component";




//calendar imports


@NgModule({ declarations: [FrontLayoutComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        UpcomingEventsComponent,
        AcademyComponent,
        UAEComponent,
        GcseClassesComponent,
        TimetableComponent,
        GcsetimetableComponent,
        TopicTestComponent,
        WebinarComponent,
        ElevplusClassesComponent,
        ProductServicesComponent, CountUpDirective, ConsortiumComponent, PageOneComponent, PageCsseComponent, PageRedbridgeComponent, PageBucksComponent, PageW11plusComponent, GrammarSchoolsComponent, ElevPlusTestsComponent, GcseTestsComponent, PageQeComponent, PageHbsComponent, PageReadingComponent, PageSuttonComponent, PageSloughComponent, RapidCourseComponent, PageBexleyComponent, CchsGirlsComponent, PageFsceComponent, PageReadingBoysComponent, PageReadingGirlsComponent, SatTestComponent, CreativeWritingComponent, SpagCourseComponent, FreeResourseComponent, PageTraffordComponent, AdmissionOpenComponent, KeyDatesComponent, LatymerComponent, BootcampComponent, BridgeCourseComponent, PythonCourseComponent, EightWeekCombinedComponent, QuestionBankComponent, BlogsComponent, BlogsReadComponent, TestComponent, DataScienceComponent, ElevenPlusSprintComponent, ElevenPlusCwComponent, LocationsComponent, LocationDetailsComponent, SafeUrlPipe, GcseLocationComponent, GcseLocationDetailsComponent, ElevenTopicTestComponent, ElevenplusHelpclubComponent, GcseHelpClubComponent, YearFourCalComponent, YearTenMocktestComponent],
    exports: [HeaderComponent, FooterComponent], imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontLayoutRoutingModule, OfferBannerComponent], providers: [CmsserviceService, CookieService, provideHttpClient(withInterceptorsFromDi())] })
export class FrontLayoutModule { }
